import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, CanMatchFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { LoginService } from '@services/login.service';
import { UsuarioPermissaoService } from '@services/usuario-permissao.service';
import { UsuarioPermissaoEnum, UsuarioPermissaoFlags } from '@utils/enums/UsuarioPermissaoEnums';
import _isNull from 'lodash/isNull';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

function handleCanActivateChild(
  next: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  const router = inject(Router);
  const usuarioPermissaoService = inject(UsuarioPermissaoService);
  const loginService = inject(LoginService);

  const menuId = next.data['menuId'];
  const usuarioLogado = loginService.checkCredentials() && localStorage['acessaVT2'];

  if (Array.isArray(menuId)) {
    return usuarioPermissaoService.usuarioPermissoes$.pipe(
      filter((value) => !_isNull(value)),
      map(() => {
        const temPermissao = menuId.some((menuIdItem: number, index: number) => {
          const flag = next.data['flag'][index] ?? UsuarioPermissaoFlags.Imprimir;
          return usuarioPermissaoService.verificarPermissao(menuIdItem, flag);
        });
        if (temPermissao) return true;
        return router.createUrlTree(['/home']);
      })
    );
  }

  switch (menuId) {
    case UsuarioPermissaoEnum.UsuarioLogado.menuId:
      if (usuarioLogado) return true;
      return router.createUrlTree(['/portal']);
    case UsuarioPermissaoEnum.UsuarioNaoLogado.menuId:
      if (!usuarioLogado) return true;
      return router.createUrlTree(['/home']);
    default:
      return usuarioPermissaoService.usuarioPermissoes$.pipe(
        filter((value) => !_isNull(value)),
        map(() => {
          const flag = next.data['flag'] ?? UsuarioPermissaoFlags.Imprimir;
          const temPermissao = usuarioPermissaoService.verificarPermissao(menuId, flag);
          if (temPermissao) return true;
          if (usuarioLogado) return router.createUrlTree(['/home']);
          return router.createUrlTree(['/portal']);
        })
      );
  }
}

export const usuarioPermissaoGuard: CanActivateFn = () => true;

export const usuarioPermissaoChildGuard: CanActivateChildFn = (next, state) =>
  handleCanActivateChild(next, state);

export const usuarioPermissaoMatchGuard: CanMatchFn = () => true;
